angular.module("Main").directive("loginHeader", loginHeader);

function loginHeader() {
    return {
        templateUrl: "./app/Main/controls/header/header.html",
        restrict: "EA",
        controller: HeaderController,
        controllerAs: "vm",
        scope: false,
        link: function (scope, element, attrs) {
            scope.hideLogin = !_.isNil(attrs.hideLogin);
        }
    };
}

HeaderController.$inject = ["$rootScope", "$scope", "$location", "$state", "$uibModal", "$translate", "tmhDynamicLocale", "$localStorage", "LANGUAGES", "SessionService", "DialogService", "BookingService"];

function HeaderController($rootScope, $scope, $location, $state, $uibModal, $translate, tmhDynamicLocale, $localStorage, LANGUAGES, SessionService, DialogService, BookingService) {
    var vm = this;

    vm.languageList = LANGUAGES;

    if($location.path() === "/customer" || $state.is("/customer")) {
        vm.isKundenportal = true;
    }
    if ($location.path() === "/kursplan" || $state.is("/kursbuchungubersicht") || $state.is("/meineterminekurs") || $location.path() === "/meineterminekurs") {
        vm.isKurse = true;
    }
    if ($location.path() === "/angebot" || $location.path() === "/termin" || $location.path() === "/uebersicht" || $state.is("/meineterminetermin") || $location.path() === "/meineterminetermin") {
        vm.isTermine = true;
    }

    init();

    var loginHandler = $rootScope.$on("login", function () {
        vm.isLoggedIn = true;
        vm.username = $localStorage.user.username;
    });

    vm.logout = function () {
        SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
        vm.isLoggedIn = false;
        vm.username = "";
        $localStorage.user = {};
        vm.username = "";
        $rootScope.$emit("logout");
    };

    vm.loginModal = function () {
        $localStorage.user = {};
        let modalInstance = $uibModal.open({
            templateUrl: "app/Main/views/dialogs/login.html",
            controller: "LoginDialogController",
            controllerAs: "vm",
            backdrop: "static",
            keyboard: false
        });

        modalInstance.result.then(function (data) {
            if (!_.isNil(data)) {
                $localStorage.user = {};
                let now = new Date;
                let hours = 6;
                //let minutes = 5;
                //let ttl = minutes * 60 * 1000
                let ttl = hours * 60 * 60 *1000;
                vm.isLoggedIn = true;
                $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                $localStorage.user.Firstname = data.user.Firstname;
                $localStorage.user.Lastname = data.user.Lastname;
                $localStorage.user.isMember = data.user.IsMember;
                $localStorage.user.memberNr = data.user.MemberNr;
                $localStorage.user.Email = data.user.Email;
                $localStorage.user.uid = data.user.uid;
                $localStorage.user.isPayPal = data.user.IsPaypal;
                $localStorage.user.isBonitaet = data.user.IsBonitaet;
                $localStorage.user.expiryTime = now.getTime() + ttl;
                $rootScope.$emit("login", vm.isLoggedIn);
            }
        });
    };

    vm.registerModal = function () {
        SessionService.clear('globals');

        DialogService.openRegisterDialog().then(function (isLoggedIn) {
            if (isLoggedIn) {
                vm.isLoggedIn = true;
                vm.username = $localStorage.username;
            }
        }).catch(function (error) {
        });
    };

    function getLocalStorageLanguage() {
        if (_.isNil($localStorage.currentLanguage))
            $localStorage.currentLanguage = _.first(LANGUAGES);

        return $localStorage.currentLanguage;
    }

    function init() {
        vm.isApp = SessionService.isApp();
        var userData =   $localStorage.user;
        if (!_.isNil(userData)) {
            vm.isLoggedIn = true;
            vm.username = $localStorage.user.username;
        } else {
            vm.isLoggedIn = false;
            vm.username = "";
        }
        if(vm.isApp) {
            vm.currentLanguage = getLocalStorageLanguage();
            tmhDynamicLocale.set(vm.currentLanguage.lang);
            $translate.use(vm.currentLanguage.lang);
        }
        BookingService.loadLayoutConfiguration().then(function (data) {
            vm.registrierungZulassen = data.RegistrierungZulassen
        })
    }
}